import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';
import { Ref } from 'vue';

export function useProductionUnitsData(production_unit: Ref<boolean>, companyId?: number) {
    const { data: productionUnitsData } = useQuery({
        queryKey: ['production-units-data'],
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.salary.employees.production-units-data', companyId),
            );
            return data;
        },
        placeholderData: [],
        enabled: !!production_unit,
    });

    return {
        productionUnitsData,
    };
}
